export const generateRandomId = (): string => {
  return Math.random().toString(36).split("").slice(2, 10).join("");
};
